/*
 * Sportsact: "Jeg accepterer handelsbetingelserne" (snippets/custom-cart-terms.liquid, runde 22).
 * - Husker fluebenet i sessionen, så det ikke forsvinder, når kurvskuffen gen-renderes efter en kurvændring.
 * - Viser indstillingens besked i stedet for browserens standardtekst, hvis man prøver at gå til betaling uden flueben.
 */
(() => {
  if (window.SportsactCartTerms) return;
  window.SportsactCartTerms = true;

  const KEY = 'sportsact-terms-accepted';
  const read = () => { try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; } };
  const write = (value) => { try { sessionStorage.setItem(KEY, value ? '1' : '0'); } catch (e) { /* privat vindue */ } };

  const sync = (root = document) => {
    root.querySelectorAll('.custom-cart-terms__input').forEach((input) => {
      input.checked = read();
      input.setCustomValidity('');
    });
  };

  document.addEventListener('change', (event) => {
    const input = event.target.closest('.custom-cart-terms__input');
    if (!input) return;
    write(input.checked);
    input.setCustomValidity('');
    input.closest('.custom-cart-terms')?.classList.remove('is-invalid');
  });

  document.addEventListener('invalid', (event) => {
    const input = event.target;
    if (!input.classList?.contains('custom-cart-terms__input')) return;
    if (input.dataset.message) input.setCustomValidity(input.dataset.message);
    input.closest('.custom-cart-terms')?.classList.add('is-invalid');
  }, true);

  // Kurvskuffen udskiftes ved hver kurvændring – sæt fluebenet igen, når nyt indhold kommer ind
  new MutationObserver((records) => {
    if (records.some((r) => [...r.addedNodes].some((n) => n.nodeType === 1 && (n.matches?.('.custom-cart-terms, .custom-cart-terms *') || n.querySelector?.('.custom-cart-terms__input'))))) sync();
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => sync());
  else sync();
})();
